import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/catch';

@Injectable()
export class PromosService {
  public promos;

  constructor(private _http: HttpClient) {}

  public getPromos() {
    return this._http
      .get('/api/promotions')
      .map((response: Response) => response)
      .toPromise()
      .catch(this.handleError);
  }

  public deletePromo(promo) {
    return this._http
      .post('/api/promotions/delete', promo)
      .map((response: Response) => response)
      .toPromise()
      .catch(this.handleError);
  }

  public addPromo(promo) {
    return this._http
      .post('/api/promotions', promo)
      .map((response: Response) => response)
      .toPromise()
      .catch(this.handleError);
  }

  // getAll() {
  //   this.promos = this.db.list('/promos');
  //   return this.promos;
  // }

  // add(promo) {
  //   this.db.list('promos').push(promo);
  // }

  // remove(promo) {
  //   let promoKey = promo.$key;
  //   this.promos
  //     .remove(promoKey)
  //     .then(result => {
  //       console.log('promo deleted:', result);
  //     })
  //     .catch(error => {
  //       console.log('could not delete promo', error);
  //     });
  // }

  private handleError(error) {
    console.error(error);
    if (error.status == 404) {
      // alert('Please change all references to /confidential/fixture/work.json to /fixture/work.json in the work.service.ts file');
    }
    return Observable.throw(error.json().error || 'Server error');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/promos/promos.service.ts